module.exports = __webpack_public_path__ + "static/media/menu.baf03c9a.svg";